export default __webpack_public_path__ + "assets/cr_xmp.6a48ba33.svg";